import { useState } from "react";

function App() {
  const intakeForm =
    "https://docs.google.com/forms/d/e/1FAIpQLSc2zm1PGkCXbBqnXPfzbR2GTI6gdLnc4I6wl_o6RLUZtausZw/viewform";
  const calendly = "https://calendly.com/blakeprimehealingarts";
  const phone = "tel:7578396043";
  const email = "mailto:blakeprimehealingarts@gmail.com";

  return (
    <div style={page}>
      <img src="/logo.PNG" alt="Blake Prime Healing Arts Logo" style={logo} />

      <h1 style={title}>Blake Prime Healing Arts</h1>
      <h2 style={tagline}>Reiki Master • Energy Healing • Spiritual Wellness</h2>

      <p style={heroText}>
        Experience relaxation, balance, and energetic alignment through
        personalized Reiki sessions designed to support healing of mind, body,
        and spirit.
      </p>

      <div style={buttonRow}>
        <a href={calendly} target="_blank" rel="noreferrer" style={button}>
          Book Online
        </a>
        <a href={intakeForm} target="_blank" rel="noreferrer" style={button}>
          Complete Intake Form
        </a>
        <a href={phone} style={button}>
          Call/Text Blake
        </a>
      </div>

      <Section title="Services">
        <Service name="60 Minute In-Person Reiki Session" price="$90">
          A complete Reiki healing experience focused on relaxation, stress
          relief, emotional support, grounding, chakra assessment as needed, and
          energetic restoration.
        </Service>

        <Service name="90 Minute In-Person Reiki Session" price="$120">
          An extended Reiki session for deeper relaxation, spiritual support,
          energy balancing, emotional processing, and expanded healing work.
        </Service>

        <Service name="Distance Reiki Session" price="$60">
          Remote Reiki healing from the comfort of your own space.
        </Service>

        <Service name="30 Minute Front Chakra Balancing Session" price="$60">
          A focused energy session designed to assess, clear, and align the
          seven primary chakras along the front of the body.
        </Service>
      </Section>

      <Section title="Seven Chakra System">
        <p style={text}>
          The primary energy centers addressed during Front Chakra Balancing and
          Reiki sessions.
        </p>

        <div style={chakraWheel}>
          <div style={chakraTop}>
            <div style={{ fontSize: "2.5rem" }}>🟣</div>
            <h3>Crown Chakra</h3>
            <p>Connection to Source & Higher Consciousness</p>
          </div>

          <div style={chakraRow}>
            <div style={chakraCard}>
              <div style={{ fontSize: "2rem" }}>🔷</div>
              <h3>Third Eye</h3>
              <p>Intuition & Inner Wisdom</p>
            </div>

            <div style={chakraCard}>
              <div style={{ fontSize: "2rem" }}>🔵</div>
              <h3>Throat</h3>
              <p>Communication & Self-Expression</p>
            </div>
          </div>

          <div style={chakraRow}>
            <div style={chakraCard}>
              <div style={heartSpear}>
                <div>▲</div>
                <div>🟢─┼─🟢</div>
                <div>▼</div>
              </div>
              <h3>Heart Chakra</h3>
              <p>Love, Compassion & Emotional Healing</p>
            </div>

            <div style={chakraCard}>
              <div style={{ fontSize: "2rem" }}>🟡</div>
              <h3>Solar Plexus</h3>
              <p>Confidence & Personal Power</p>
            </div>
          </div>

          <div style={chakraRow}>
            <div style={chakraCard}>
              <div style={{ fontSize: "2rem" }}>🟠</div>
              <h3>Sacral</h3>
              <p>Creativity & Flow</p>
            </div>

            <div style={chakraCard}>
              <div style={{ fontSize: "2rem" }}>🔴</div>
              <h3>Root</h3>
              <p>Grounding & Stability</p>
            </div>
          </div>
        </div>
      </Section>

      <Section title="About Blake">
        <p style={text}>
          My name is Blake Scott, Reiki Master and founder of Blake Prime
          Healing Arts LLC. My mission is to provide a safe and supportive space
          where clients can reduce stress, restore energetic balance, and
          reconnect with their highest potential.
        </p>
      </Section>

      <Section title="Client Testimonials">
        <Testimonial>
          “Blake created a peaceful environment and helped me feel relaxed and balanced.”
        </Testimonial>
        <Testimonial>
          “I felt calmer, lighter, and more centered after my session.”
        </Testimonial>
        <Testimonial>
          “A welcoming healing experience that helped me reconnect with myself.”
        </Testimonial>
      </Section>

      <Section title="Frequently Asked Questions">
        <FAQ q="What is Reiki?">
          Reiki is a gentle energy healing practice that promotes relaxation,
          stress reduction, balance, and overall well-being.
        </FAQ>

        <FAQ q="What is the difference between Reiki and Front Chakra Balancing?">
          A Reiki session is a complete healing experience that may include
          grounding, full-body Reiki, chakra assessment, and energetic balancing.
          Front Chakra Balancing is a shorter, focused 30-minute session centered
          specifically on the seven front-body chakras.
        </FAQ>

        <FAQ q="What should I wear?">
          Wear comfortable clothing. You remain fully clothed during your session.
        </FAQ>

        <FAQ q="How do I book?">
          You can book online through Calendly, complete the intake form, or
          call/text Blake directly.
        </FAQ>
      </Section>

      <Section title="Contact">
        <p>📧 blakeprimehealingarts@gmail.com</p>
        <p>📞 (757) 839-6043</p>
        <p>📍 Maryland & Distance Reiki Available</p>

        <div style={buttonRow}>
          <a href={email} style={button}>Email Blake</a>
          <a href={phone} style={button}>Call/Text</a>
        </div>
      </Section>

      <p style={disclaimer}>
        Reiki is a complementary wellness practice and is not intended to
        diagnose, treat, cure, or prevent disease. Please consult a licensed
        healthcare provider for medical concerns.
      </p>

      <footer style={footer}>
        © 2026 Blake Prime Healing Arts LLC. All Rights Reserved.
      </footer>

      <ChatBot />
    </div>
  );
}

function ChatBot() {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([
    {
      from: "bot",
      text:
        "Peace and welcome. I’m Blake Prime Assistant. Ask me about Reiki, front chakra balancing, distance Reiki, pricing, preparation, or which session may be best for you.",
    },
  ]);
  const [input, setInput] = useState("");

  const intakeForm =
    "https://docs.google.com/forms/d/e/1FAIpQLSc2zm1PGkCXbBqnXPfzbR2GTI6gdLnc4I6wl_o6RLUZtausZw/viewform";
  const calendly = "https://calendly.com/blakeprimehealingarts";

  function getReply(question) {
    const q = question.toLowerCase();

    if (q.includes("price") || q.includes("cost") || q.includes("pricing")) {
      return "Services: 60 Minute In-Person Reiki Session — $90, 90 Minute In-Person Reiki Session — $120, Distance Reiki Session — $60, and 30 Minute Front Chakra Balancing Session — $60.";
    }

    if (q.includes("front chakra") || q.includes("chakra balancing") || q.includes("chaka")) {
      return "The 30 Minute Front Chakra Balancing Session is $60. It focuses on the seven front-body chakras: root, sacral, solar plexus, heart, throat, third eye, and crown. It is best for energetic alignment, feeling blocked, or wanting a focused chakra reset.";
    }

    if (q.includes("recommend") || q.includes("which session") || q.includes("best for me")) {
      return "For general relaxation and stress relief, I recommend the 60-minute Reiki session. For deeper support, choose the 90-minute session. For a shorter focused chakra reset, choose the 30 Minute Front Chakra Balancing Session.";
    }

    if (q.includes("stress") || q.includes("anxiety") || q.includes("overwhelmed")) {
      return "For stress or feeling overwhelmed, a 60-minute in-person Reiki session may be a good choice. Reiki may support relaxation, emotional balance, grounding, and peace.";
    }

    if (q.includes("blocked") || q.includes("stuck") || q.includes("drained")) {
      return "If you feel blocked, stuck, or drained, the 30 Minute Front Chakra Balancing Session may be helpful for chakra alignment, clarity, and grounding.";
    }

    if (q.includes("reiki")) {
      return "Reiki is a gentle energy healing practice that supports relaxation, stress reduction, energetic balance, and overall wellness. It is complementary wellness and not a replacement for medical care.";
    }

    if (q.includes("distance") || q.includes("remote")) {
      return "Distance Reiki is performed remotely. You can relax in your own space while Reiki energy is shared with intention toward your session goals. It is $60.";
    }

    if (q.includes("book") || q.includes("appointment") || q.includes("schedule")) {
      return `You can book online here: ${calendly}. You may also complete the intake form first: ${intakeForm}.`;
    }

    if (q.includes("phone") || q.includes("call") || q.includes("text")) {
      return "You can call or text Blake at (757) 839-6043.";
    }

    if (q.includes("email")) {
      return "You can email Blake Prime Healing Arts at blakeprimehealingarts@gmail.com.";
    }

    if (q.includes("medical") || q.includes("doctor") || q.includes("diagnose")) {
      return "Reiki is not medical treatment and is not intended to diagnose, treat, cure, or prevent disease. Please consult a licensed healthcare provider for medical concerns.";
    }

    return "That’s a great Reiki question. I can help with Reiki, front chakra balancing, distance Reiki, pricing, preparation, and booking. For personal guidance, complete the intake form or call/text Blake at (757) 839-6043.";
  }

  function sendMessage(textFromButton) {
    const messageText = textFromButton || input;
    if (!messageText.trim()) return;

    setMessages([
      ...messages,
      { from: "user", text: messageText },
      { from: "bot", text: getReply(messageText) },
    ]);

    setInput("");
  }

  return (
    <>
      <button onClick={() => setOpen(!open)} style={chatButton}>
        💬 Ask Blake Prime
      </button>

      {open && (
        <div style={chatWindow}>
          <div style={chatHeader}>Blake Prime Assistant</div>

          <div style={quickBox}>
            {[
              "What is Reiki?",
              "Pricing",
              "Front Chakra Balancing",
              "I feel stressed",
              "I feel blocked",
              "Distance Reiki",
              "Book a Session",
            ].map((question) => (
              <button key={question} onClick={() => sendMessage(question)} style={quickButton}>
                {question}
              </button>
            ))}
          </div>

          <div style={chatMessages}>
            {messages.map((msg, index) => (
              <div key={index} style={msg.from === "bot" ? botBubble : userBubble}>
                {msg.text}
              </div>
            ))}
          </div>

          <div style={chatInputRow}>
            <input
              style={chatInput}
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && sendMessage()}
              placeholder="Ask a Reiki question..."
            />
            <button onClick={() => sendMessage()} style={sendButton}>Send</button>
          </div>
        </div>
      )}
    </>
  );
}

function Section({ title, children }) {
  return (
    <section style={section}>
      <h2>{title}</h2>
      {children}
    </section>
  );
}

function Service({ name, price, children }) {
  return (
    <div style={serviceBox}>
      <h3>✨ {name} — {price}</h3>
      <p style={smallText}>{children}</p>
    </div>
  );
}

function FAQ({ q, children }) {
  return (
    <div style={faqBox}>
      <h3>{q}</h3>
      <p style={faqText}>{children}</p>
    </div>
  );
}

function Testimonial({ children }) {
  return (
    <div style={testimonialBox}>
      <p>★★★★★</p>
      <p style={faqText}>{children}</p>
    </div>
  );
}

const page = {
  backgroundColor: "#050505",
  color: "#d4af37",
  minHeight: "100vh",
  padding: "40px 20px",
  textAlign: "center",
  fontFamily: "Arial, sans-serif",
};

const logo = {
  width: "220px",
  maxWidth: "80%",
  marginBottom: "20px",
  filter: "drop-shadow(0 0 25px rgba(212,175,55,0.5))",
};

const title = {
  fontSize: "clamp(2rem, 8vw, 4rem)",
  marginBottom: "10px",
  lineHeight: "1.1",
  maxWidth: "900px",
  margin: "0 auto",
  textShadow: "0 0 20px rgba(212,175,55,0.5)",
};

const tagline = {
  fontSize: "1.4rem",
  fontWeight: "600",
  marginBottom: "15px",
};

const heroText = {
  maxWidth: "800px",
  margin: "0 auto",
  lineHeight: "1.8",
  fontSize: "1.1rem",
  color: "#f5f5f5",
};

const text = {
  maxWidth: "850px",
  margin: "20px auto",
  color: "#f5f5f5",
  lineHeight: "1.8",
};

const smallText = {
  color: "#ccc",
  maxWidth: "700px",
  margin: "0 auto 25px",
};

const section = {
  marginTop: "70px",
  lineHeight: "2",
};

const serviceBox = {
  maxWidth: "850px",
  margin: "20px auto",
  padding: "18px",
  borderBottom: "1px solid #333",
};

const chakraWheel = {
  maxWidth: "900px",
  margin: "0 auto",
  padding: "30px",
  border: "1px solid #d4af37",
  borderRadius: "15px",
  backgroundColor: "#0d0d0d",
};

const chakraTop = {
  textAlign: "center",
  marginBottom: "30px",
};

const chakraRow = {
  display: "flex",
  justifyContent: "space-around",
  flexWrap: "wrap",
  gap: "20px",
  marginTop: "20px",
};

const chakraCard = {
  flex: "1",
  minWidth: "220px",
  padding: "15px",
  textAlign: "center",
};

const heartSpear = {
  fontSize: "1.4rem",
  lineHeight: "1.2",
  color: "#00ff66",
  textShadow: "0 0 12px rgba(0,255,102,0.7)",
};

const faqBox = {
  maxWidth: "850px",
  margin: "20px auto",
  padding: "20px",
  border: "1px solid #d4af37",
  borderRadius: "12px",
  backgroundColor: "#0d0d0d",
};

const testimonialBox = {
  maxWidth: "850px",
  margin: "20px auto",
  padding: "20px",
  border: "1px solid #d4af37",
  borderRadius: "12px",
  backgroundColor: "#0d0d0d",
};

const faqText = {
  color: "#f5f5f5",
};

const buttonRow = {
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  gap: "15px",
  marginTop: "25px",
};

const button = {
  display: "inline-block",
  background: "#d4af37",
  color: "#000",
  padding: "15px 28px",
  borderRadius: "10px",
  textDecoration: "none",
  fontWeight: "bold",
};

const disclaimer = {
  maxWidth: "850px",
  margin: "70px auto 20px",
  fontSize: "13px",
  color: "#999",
};

const footer = {
  marginTop: "40px",
  borderTop: "1px solid #333",
  paddingTop: "20px",
  color: "#777",
};

const chatButton = {
  position: "fixed",
  bottom: "90px",
  right: "15px",
  background: "#d4af37",
  color: "#000",
  border: "none",
  padding: "12px 16px",
  borderRadius: "50px",
  fontWeight: "bold",
  cursor: "pointer",
  boxShadow: "0 0 20px rgba(212,175,55,0.5)",
  zIndex: 1000,
};

const chatWindow = {
  position: "fixed",
  bottom: "150px",
  right: "15px",
  width: "370px",
  maxWidth: "92vw",
  height: "560px",
  background: "#111",
  border: "1px solid #d4af37",
  borderRadius: "15px",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  zIndex: 1000,
};

const chatHeader = {
  background: "#d4af37",
  color: "#000",
  padding: "15px",
  fontWeight: "bold",
};

const quickBox = {
  display: "flex",
  flexWrap: "wrap",
  gap: "8px",
  padding: "10px",
  borderBottom: "1px solid #333",
};

const quickButton = {
  background: "#222",
  color: "#d4af37",
  border: "1px solid #d4af37",
  borderRadius: "20px",
  padding: "7px 10px",
  cursor: "pointer",
  fontSize: "12px",
};

const chatMessages = {
  flex: 1,
  padding: "15px",
  overflowY: "auto",
  textAlign: "left",
};

const botBubble = {
  background: "#222",
  color: "#fff",
  padding: "10px",
  borderRadius: "10px",
  marginBottom: "10px",
};

const userBubble = {
  background: "#d4af37",
  color: "#000",
  padding: "10px",
  borderRadius: "10px",
  marginBottom: "10px",
  marginLeft: "40px",
};

const chatInputRow = {
  display: "flex",
  borderTop: "1px solid #333",
};

const chatInput = {
  flex: 1,
  padding: "12px",
  border: "none",
  outline: "none",
};

const sendButton = {
  background: "#d4af37",
  color: "#000",
  border: "none",
  padding: "12px",
  fontWeight: "bold",
  cursor: "pointer",
};

export default App;